import { lighten } from 'polished';

import { core } from '../styles/core';

/**
 *  @deprecated since version 3.0.0-alpha.58, please use theme.palette[name] lighter or lightest keywords
 */
export const exclusiveColor = {
  primary: {
    light2: lighten(0.3, core.palette.primary.main),
    light3: lighten(0.45, core.palette.primary.main),
  },
  secondary: {
    light2: lighten(0.3, core.palette.secondary.main),
    light3: lighten(0.45, core.palette.secondary.main),
  },
  error: {
    light2: lighten(0.35, core.palette.error.main),
  },
  success: {
    light2: lighten(0.4, core.palette.success.main),
  },
  warning: {
    light2: lighten(0.3, core.palette.warning.main),
  },
  info: {
    light2: lighten(0.35, core.palette.info.main),
  },
};
